import React, { useEffect, useState } from 'react';

import styled from 'styled-components';

import EmptyState from '@components/Gui/EmptyState';
import FlexContainer from '@components/Gui/FlexContainer';
import { NwCancelButton, NwSaveButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';

import { UploadsGridLayout } from '@containers/Art/Uploads/UploadsGrid.styles';
import UploadsGridTile from '@containers/Art/Uploads/UploadsGridTile';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ListContainer = styled.div`
    margin: 0 1rem 6rem 1rem;
`;

const FooterContainer = styled.div`
    z-index: 100;
    position: fixed;
    bottom: 0;
    left: 10vw;
    background-color: #fff;
    padding: 16px 24px;
    box-sizing: border-box;
    width: 90vw;
    box-shadow: 0 -6px 18px rgba(0, 0, 0, 0.08);
    font-weight: bold;
    text-transform: uppercase;
`;

const UploadsSelectableGrid = ({
    clearSelectionToken,
    emptyMessage = 'No uploads found',
    onSelectionChange,
    onSaveSelection,
    uploads = [],
}) => {
    const [selectedUploads, setSelectedUploads] = useState([]);

    useEffect(() => {
        setSelectedUploads([]);
    }, [clearSelectionToken]);

    useEffect(() => {
        if (onSelectionChange) {
            onSelectionChange(selectedUploads);
        }
    }, [onSelectionChange, selectedUploads]);

    if (!uploads.length) {
        return <EmptyState message={emptyMessage} />;
    }

    const handleSelectUpload = (upload) => {
        const index = selectedUploads.findIndex((item) => item.ID === upload.ID);
        if (index >= 0) {
            const nextSelectedUploads = [...selectedUploads];
            nextSelectedUploads.splice(index, 1);
            setSelectedUploads(nextSelectedUploads);
            return;
        }

        setSelectedUploads([...selectedUploads, upload]);
    };

    const handleDeselectUpload = (upload) => {
        setSelectedUploads(selectedUploads.filter((item) => item.ID !== upload.ID));
    };

    const handleSaveSelection = () => {
        if (!selectedUploads.length) return;
        onSaveSelection(selectedUploads);
    };

    const renderBadge = (upload) => {
        const index = selectedUploads.findIndex((item) => item.ID === upload.ID);
        if (index === -1) return null;

        return (
            <div
                className="count-badge"
                onClick={(event) => {
                    event.stopPropagation();
                    handleDeselectUpload(upload);
                }}
            >
                <div className="number">{index + 1}</div>
                <div className="icon">
                    <NwIcon icon={byPrefixAndName.fasl['times']} />
                </div>
            </div>
        );
    };

    return (
        <>
            <ListContainer>
                <UploadsGridLayout>
                    {uploads.map((upload) => (
                        <UploadsGridTile
                            key={upload.ID}
                            badge={renderBadge(upload)}
                            isSelected={selectedUploads.some((item) => item.ID === upload.ID)}
                            upload={upload}
                            onClick={handleSelectUpload}
                        />
                    ))}
                </UploadsGridLayout>
            </ListContainer>
            <FooterContainer>
                <FlexContainer fullWidth justifyContent="space-between">
                    <div>{selectedUploads.length} selected media</div>
                    <FlexContainer>
                        <NwSaveButton
                            disabled={selectedUploads.length === 0}
                            style={{ marginRight: '20px' }}
                            onClick={handleSaveSelection}
                        />
                        <NwCancelButton onClick={() => setSelectedUploads([])} />
                    </FlexContainer>
                </FlexContainer>
            </FooterContainer>
        </>
    );
};

export default UploadsSelectableGrid;
